export default "__VITE_ASSET__d49770b6__"